export function getReadTime(text) {
    const readTime = {
        rate: 200,
        wordcount: text
            .replace(/[\d\s]+/gm, " ")
            .split(/\W+/gm)
            .filter((c) => (c.length > 1 ? c : false)).length,
        text: text,
    };
    readTime.time =
        Math.round((readTime.wordcount / readTime.rate) * 100) / 100;
    const time = String(readTime.time).split(".");
    readTime.hours = Math.floor(Number(time[0]) / 60);
    readTime.minutes = Number(time[0]) % 60;
    readTime.seconds = time[1] ? Math.round((Number(time[1]) * 60) / 100) : 0;
    readTime.round = Math.round(Number(`0.${time[1] || 0}`));
    return readTime;
}
